// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5190d85d","453":"e988feca","796":"983d1e8e"}[chunkId] + ".chunk.js";
};